import * as Sentry from "@sentry/react";

// Frontend Sentry init — gated on REACT_APP_SENTRY_DSN. CRA inlines
// REACT_APP_* env vars at build time, so the runtime check below
// resolves to a literal string at build, and the whole block becomes
// a no-op when the DSN was never configured.
export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV || "production",
    release: process.env.REACT_APP_SENTRY_RELEASE || process.env.REACT_APP_GIT_SHA,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Conservative sampling for the launch — the dashboard is mostly
    // navigation and async-query traffic, so 10% gives us signal without
    // chewing through quota. Replay only fires on errors.
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_RATE || "0.1"),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

export { Sentry };
